import React, { Component } from 'react';
import ReactModal from 'react-modal';
import { bodyScroll } from '../../../utils/utils';

import TermsList from './TermsList';
import NewAssessmentFlagIcon from '../../icons/NewAssessmentFlagIcon';
import CloseIcon from '../../icons/CloseIcon';
import FlagIcon from '../../icons/FlagIcon';

class StickyButtons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      termsExpanded: false,
      flagExpanded: false,
    };
  }

  handleTermsClick = () => {
    bodyScroll.toggle(true); // snap to top since it's not a floating modal
    this.setState(prevState => ({ termsExpanded: !prevState.termsExpanded }));
  }

  handleFlagClick = () => {
    bodyScroll.toggle(true); // snap to top since it's not a floating modal
    this.setState(prevState => ({ flagExpanded: !prevState.flagExpanded }));
  }

  focusTermsContent = () => {
    document.querySelector('.new-assessment-sticky-buttons__content dl').focus();
  }

  focusFlagContent = () => {
    document.querySelector('.new-assessment-sticky-buttons__content').focus();
  }

  render() {
    const { toggleFlag, flagged } = this.props;
    const { termsExpanded, flagExpanded } = this.state;
    return (
      <div className="new-assessment-sticky-buttons">
        <div className="new-assessment-sticky-buttons__buttons">
          <button
            type="button"
            className="button button--brand new-assessment-sticky-buttons__button new-assessment-sticky-buttons__button--flag"
            onClick={this.handleFlagClick}
          >
            Flag
            <NewAssessmentFlagIcon flagged={flagged} />
          </button>
          <button
            type="button"
            onClick={this.handleTermsClick}
            className="button button--dark-gray new-assessment-sticky-buttons__button"
          >
            Terms &amp; Definitions
          </button>
        </div>
        <ReactModal
          isOpen={flagExpanded}
          onRequestClose={this.handleFlagClick}
          className={{
            base: 'transition',
            afterOpen: 'transition--active',
            beforeClose: 'transition--close',
          }}
          overlayClassName="new-assessment-sticky-buttons__overlay"
          closeTimeoutMS={500}
          onAfterOpen={this.focusFlagContent}
        >
          <div className="new-assessment-sticky-buttons__flag-modal text">
            <button type="button" className="new-assessment-sticky-buttons__close-button" onClick={this.handleFlagClick}>
              <CloseIcon />
            </button>
            <div className="new-assessment-sticky-buttons__content">
              <h2>
                Flagged Questions
              </h2>
              <div className="new-assessment-sticky-buttons__content-flagged-questions">
                <p>
                  While working on an assessment, you can click on the flag button below to mark a question. Flagging is the digital equivalent of dog-earing a page or circling a question on the print version for later reference.
                </p>
                <p>
                  Flagging questions can be helpful to draw attention to an opportunity for improvement or a change over time. You can see how many questions you’ve flagged in a given assessment by hovering over the flag icon on the Dashboard.
                </p>
                <button
                  type="button"
                  className="button new-assessment-sticky-buttons__flag-modal-button"
                  onClick={toggleFlag}
                >
                  Flag Question
                  <FlagIcon flagged={flagged} />
                </button>
              </div>
            </div>
          </div>
        </ReactModal>
        <ReactModal
          isOpen={termsExpanded}
          onRequestClose={this.handleTermsClick}
          className={{
            base: 'transition',
            afterOpen: 'transition--active',
            beforeClose: 'transition--close',
          }}
          overlayClassName="new-assessment-sticky-buttons__overlay"
          closeTimeoutMS={500}
          onAfterOpen={this.focusTermsContent}
        >
          <div className="new-assessment-sticky-buttons__terms text">
            <button type="button" className="new-assessment-sticky-buttons__close-button" onClick={this.handleTermsClick}>
              <CloseIcon />
            </button>
            <div className="new-assessment-sticky-buttons__content">
              <h2>
                Terms &amp; Definitions
              </h2>
              <TermsList />
            </div>
          </div>
        </ReactModal>
      </div>
    );
  }
}

export default StickyButtons;



// WEBPACK FOOTER //
// ./src/components/features/assessment/StickyButtons.js